import english_us from './translation/en-US';
import french_france from './translation/fr-FR';
import { type SupportedLocale } from './translation_locale';

export {
  type SupportedLocale,
  SUPPORTED_LOCALES,
  isSupportedLocale,
  TRANSLATED_LOCALES,
  isTranslatedLocale,
  stripLocalePrefix,
} from './translation_locale';

export const MAPPED_TRANSLATION = {
  'fr-FR': french_france,
  'en-US': english_us,
} as const;

// Dédup des traductions manquantes déjà signalées — un même trou serait sinon
// logué à chaque notification/rendu (ex. un pro non-francophone).
const warnedMissingTranslations = new Set<string>();

/**
 * Pure translation lookup, locale-explicit. Use this in environments where the
 * locale isn't implicit (server, mobile, workers). For React components in the
 * web app, prefer `useTranslations()` from next-intl.
 *
 * Toute clé introuvable est signalée UNE fois dans les logs (`[i18n] …`) : les
 * appelants enchaînent en général un fallback fr-FR silencieux — sans cette
 * trace, une traduction oubliée passerait inaperçue.
 */
export function translate(locale: SupportedLocale, namespace: string, key: string): string | undefined {
  const messages = MAPPED_TRANSLATION[locale] as Record<string, unknown> | undefined;
  const dict = messages?.[namespace] as Record<string, string> | undefined;
  const value = dict?.[key];
  if (value === undefined) {
    const warnKey = `${locale}:${namespace}.${key}`;
    if (!warnedMissingTranslations.has(warnKey)) {
      warnedMissingTranslations.add(warnKey);
      console.warn(`[i18n] Traduction manquante : ${namespace}.${key} (${locale})`);
    }
  }
  return value;
}
